import { createAction, props } from '@ngrx/store';
import { SkillApiError } from './skills.errors';
import { Skill } from './models/skills.model';
import { SkillsUsage } from './models/skills-usage.model';

export const KnowledgeConfigInitialized = createAction('[Knowledge Config] Initialized');

export const SkillsLoadedAction = createAction(
  '[Skill Effect] Skills Loaded',
  props<{ skills: Skill[] }>(),
);

export const SkillsErroredAction = createAction(
  '[Skill Effect] Skills Errored',
  props<{ error: SkillApiError }>(),
);

export const CreateSkillAction = createAction(
  '[Skill Effect] Create Skill',
  props<{ values: Record<string, unknown> }>(),
);

export const UpdateSkillAction = createAction(
  '[Skill Effect] Update Skill',
  props<{ values: Record<string, unknown>; id: string }>(),
);

export const DeleteSkillAction = createAction(
  '[Skill Effect] Delete Skill',
  props<{ id: string }>(),
);

export const LoadSkillAction = createAction('[Skill Effect] Load Skill', props<{ id: string }>());

export const LoadSkillSucceededAction = createAction(
  '[Skill Effect] Load Skill Succeeded',
  props<{ skill: Skill }>(),
);

export const LoadSkillErroredAction = createAction(
  '[Skill Effect] Load Skill Errored',
  props<{ error: SkillApiError }>(),
);

export const LoadSkillsAsOrgUserAction = createAction('[Skill Effect] Load Skills As Org User');

export const SkillsLoadedAsOrgUserAction = createAction(
  '[Skill Effect] Skills Loaded As Org User',
  props<{ skills: Skill[] }>(),
);

export const DeleteSkillSuccessAction = createAction(
  '[Skill Effect] Skill Successfully Deleted',
  props<{ id: string }>(),
);

export const LoadSkillsUsageAction = createAction('[Skill Effect] Load Skills Usage');

export const SkillsUsageLoadedAction = createAction(
  '[Skill Effect] Skills Usage Loaded',
  props<{ skillsUsage: SkillsUsage[] }>(),
);

export const RemoveSkillsErrorAction = createAction('[Skill Effect] Remove Skills Error');

export const GoToSkillDetailPageAction = createAction('[Skill Effect] Go to Skill Detail Page');
